<template>
  <v-container fluid class="mx-0 px-0">
      <v-row no-gutters class="mb-10">
        <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0 hidden-md-and-down">
            <v-img
                width="100%"
                contain 
                :src="require('@/assets/members.jpg')">
            </v-img>
        </v-col>
      </v-row>
      <!-- <v-row no-gutters justify="center" align="center" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
        <div v-for="(group, index) in vip" :key="index">
          <v-col v-if="index" cols=12 lg=4 justify="center" align="center">
            <v-btn
              rounded
              small
              color="#1b2f5a"
              dark
              @click="goTo(index)"
            >
              {{index}}
            </v-btn>
          </v-col>
        </div>
      </v-row> -->
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="#1b2f5a"
        @click="toTop()"
      >
            <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
      <div>
        <v-row justify="center" align="center" class ="my-5" :ref="index" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col justify="center" align="center" cols=2>
                <v-divider></v-divider>
            </v-col>
            <v-col justify="center" align="center" class="title my-15" cols=8>
                VIP
            </v-col>
            <v-col justify="center" align="center" cols=2>
                <v-divider></v-divider>
            </v-col>
            <v-col class="text-center" cols=12 xs="12" sm="12" md="6" lg="4" v-for="member in vip" :key="member.id">
              <v-avatar
                color="#1b2f5a"
                size="20vw"
              >
                <v-img
                  v-if="member.image"
                  class="white--text align-end"
                  :src="getMemberImage(member)"
                />
                <v-img 
                  v-else
                  class="white--text align-end"
                  height="auto"
                  width="30vw"
                  :src="getImage()"
                />
              </v-avatar>
              <v-row class="text" :style="$vuetify.breakpoint.mobile ? 'font-size: 14px' : 'font-size: 16px'"> 
                <v-col class="text-center" cols=12>
                  {{member.firstName + ' ' + member.lastName + (member.profession ? ' - ' + member.profession : "")}}
                </v-col>
              </v-row>

            </v-col>  
        </v-row>
      </div>
  </v-container>
</template>


<script>
  import restApi from "@/rest-api";

  export default {
    data() {
        return {
            vip: {},
            fab: false
        }
    },
    created() {
        this.fetchVip();
    },
    methods: {
      getImage() {
        return require('@/assets/LOGOPARON 2023.svg')
      },
      getMemberImage(member) {
        return `https://dev.paron-card.gr/uploads/images/${member.image.imageName}`
      },
      fetchVip() {
        var search = `/member/vip`;
        restApi
        .get(search)
        .then(response => {
              this.vip = response.data
              // this.vip = response.data.sort(
              //       (a,b) => a.lastName < b.lastName ? -1 : 1
              //   )
        })
        .catch((error) => {
            console.log(error);
        });
      },
      goTo(index) {
        this.$vuetify.goTo(this.$refs[index][0]);
      },
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset ||   e.target.scrollTop || 0
        this.fab = top > 20
      },
      toTop() {
        this.$vuetify.goTo(0)
      }
    }
  }
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){

        .title{
          font-weight: bold;
          font-size: 5vh!important;
        }
    }

    @media only screen and (max-width: 600px){

        .title{
          font-weight: bold;
          font-size: 4vh!important;
      }
    }

    .theme--light.v-divider {
      border-color: rgb(0 0 0);
    }

    .v-divider--vertical {
      border-width: 300px thin 100px 0;
    }
</style>